import { Acma_senderidauthorisation_statuscode, Authorisation, AuthorisationRequest, Client, Hint, Settings, SettingsBase } from "../api";
import { ListCache } from "./ListCache";

const _cache = new ListCache<Settings>()

export class SettingsStore {
  client: Client

  constructor(client: Client) {
    this.client = client;
  }

  async getSettings() {
    var res = await this.client.getSettings();

    return {
      settings: _cache.mergeServerData(res.settings ?? [], r => r.clientId, 50, [r => r.clientName, false]),
      mnOs: res.mnOs,
      implementers: res.implementers,
      consent: res.consent
    }
  }

  async updateSettings(body: SettingsBase[] | undefined) {
    var res = await this.client.updateSettings(body);
    for (var r of res) {
      if (r.clientId) {
        _cache.set(r.clientId, r);
      }
    }
    return res;
  }
}